var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"campaign-media"},[(_vm.mediaList && _vm.mediaList.length)?_c('media-carousel',{attrs:{"media-list":_vm.mediaList,"zoomable":_vm.zoomable,"playable":_vm.playable,"controls":_vm.controls,"dimensions":_vm.dimensions}}):_c('media',{attrs:{"media":_vm.media}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }